@if (!!parentFormGroup().get(controlName())) {
  <mat-form-field
    [formGroup]="parentFormGroup()"
    appearance="outline"
    class="form-field w-full"
    [class.small]="type() === 'small'"
    [class.hide-subscript]="hideSubscript()"
  >
    @if (label()) {
      <mat-label>{{label()}}</mat-label>
    }
    <input
      [formControlName]="controlName()"
      class="input text-input"
      matInput
      [placeholder]="placeholder()"
      type="text"
      [maxlength]="maxLength()"
    >
    @if (suffixIcon()) {
      <mat-icon
        class="cursor-pointer"
        matSuffix
        (click)="suffixClick()"
      >
        {{suffixIcon()}}
      </mat-icon>
    }
    @if (suffixSvgIcon()) {
      <mat-icon
        class="cursor-pointer"
        matSuffix
        (click)="suffixClick()"
        [svgIcon]="suffixSvgIcon()"
      />
    }
    @if (prefixIcon()) {
      <mat-icon
        class="cursor-pointer"
        matPrefix
        (click)="prefixClick()"
      >
        {{prefixIcon()}}
      </mat-icon>
    }
    @if (prefixSvgIcon()) {
      <mat-icon
        class="cursor-pointer"
        matPrefix
        (click)="prefixClick()"
        [svgIcon]="prefixSvgIcon()"
      />
    }
    <mat-error *ngIf="error()">{{ error() }}</mat-error>
  </mat-form-field>
}
